import React from 'react';
import { useTranslation } from 'react-i18next';
import './FirstProjectOnboarding.scss';
import { TRIAL_ADVISOR } from '../../../constans/constans';
import onboardingGif from '../../../../assets/images/first-project-onboarding.gif';

interface FirstProjectOnboardingContentProps {
  onClose: () => void;
}

const FirstProjectOnboardingContent: React.FC<FirstProjectOnboardingContentProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleBookDemo = () => {
    window.open(TRIAL_ADVISOR.calendly, '_blank', 'noopener');
  };

  return (
    <div className="first-project-onboarding">
      <div className="first-project-onboarding__gif">
        <img src={onboardingGif} alt="Onboarding" />
      </div>
      <p className="first-project-onboarding__copy" dangerouslySetInnerHTML={{ __html: t('firstProjectOnboarding.copy') }} />
      <div className="first-project-onboarding__actions">
        <button className="first-project-onboarding__btn--secondary" onClick={handleBookDemo}>
          {t('bookADemo')}
        </button>
        <button className="first-project-onboarding__btn--primary" onClick={onClose}>
          {t('goToProject')}
        </button>
      </div>
    </div>
  );
};

export default FirstProjectOnboardingContent;
